<template>
	<v-container style="background-color: #ffffff">
		<p class="text-center" style="font-size: 16px; margin-left: 10px;">Under this tab, you'll find all the deactivated risk matrices that are not actively in use. </p>
		<v-col cols="12" class="pt-8">
			<v-card elevation="0" outlined>
				<v-data-table
					:loading="loading"
					theme
					light
					:headers="headers"
					:items="items"
					:footer-props="{
						'items-per-page-options': [5, 10, 15],
					}"
					:items-per-page="5"
					class="light table"
					@click:row="selectRow"
				>
					<template v-slot:item="{ item, index }">
						<tr
							:class="{ 'selected-row': selectedRowIndex === index }"
							@click="selectRow(item, index)"
						>
							<td>{{ item.Title }}</td>
							<td><span style="padding-left: 	15px;">{{ item.Year }}</span></td>
							<td>
								<span
									v-if="item.Status === 'Active'"
									class="success--text font-weight-bold"
									>Active</span
								>
								<span v-else class="error--text font-italic font-weight-bold" style="padding-left: 	15px;"

									>Inactive</span
								>
							</td>
							<td>
								<v-btn
									v-on:click="makeitInactive(item)"
									v-if="item.Status === 'Active'"
									class="error--text font-italic font-weight-bold"
									>Deactivate</v-btn
								>
								<v-btn
									v-on:click="makeitActive(item)"
									v-else
									class="success--text font-weight-bold"
									>Activate</v-btn
								>
							</td>
							<td>
								<v-btn
									small
									color="primary"
									style="border-radius: 2px; margin-left:20px;"
									@click.stop="deleteItem(item)"
								>
									<v-icon small>fas fa-xmark</v-icon>
								</v-btn>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-card>
		</v-col>
		<div class="toplayermargin" ref="riskMatrixPoint">
			<Riskmatrixwithpoint />
		</div>
		<div>
			<Riskmatrixwithtable />
		</div>
		<br />
		<br />
		<div>
			<ActionPlanRisk />
		</div>
		<v-dialog v-model="dialogDelete" max-width="500px">
				<v-card>
					<v-card-title
						>Are you sure you want to remove this Risk Matrix?</v-card-title
					>
					<v-card-text
						>Once it is removed, you will not able to track your all
						risk data</v-card-text
					>
					<v-card-actions>
						<v-btn color="primary" text @click="dialogDelete = false"
							>Close</v-btn
						>
						<v-btn color="error" text @click="removeRow">Delete</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
	</v-container>
</template>

<script>
import Riskmatrixwithpoint from "../components/Riskmatrixwithpoint.vue"
import Riskmatrixwithtable from "../components/Riskmatrixwithtable.vue"
import ActionPlanRisk from "../components/ActionPlanRisk.vue"
import LoadingState from "../consts/LoadingState"
import { riskmatrixAPI } from "../api/csr/riskmatrix"

export default {
	components: {
		Riskmatrixwithpoint,
		ActionPlanRisk,
		Riskmatrixwithtable,
	},

	data() {
		return {
			dialog: false,
			dialog2: false, // Dialog 2 for update
			dialogDelete:false,
			hasScrolled: false,
			delete:"",
			items: [],
			selectedRowIndex: null,
			newMatrixTitle: "", // Reused for both creating and updating
			newMatrixYear: "",
			newMatrixDescription: "",
			headers: [
				{
					text: "Title",
					value: "title",
					sortable: false,
					class: "darkColor--text",
				},
				{
					text: "Date",
					value: "date",
					sortable: false,
					class: "darkColor--text",
				},
				{
					text: "Status",
					value: "active",
					sortable: false,
					class: "darkColor--text",
				},
				{
					text: "Activate",
					value: "remove",
					sortable: false,
					class: "darkColor--text",
				},
				{
					text: "Remove",
					value: "delete",
					sortable: false,
					class: "darkColor--text",
				},
			],
		}
	},
	mounted() {
		console.log("here in mount")
		this.hasScrolled = false
	},
	watch: {
		"$store.getters.selectedStatus": {
			immediate: true,
			handler(newStatus) {
				if (newStatus === "Inactive") {
					this.hasScrolled = false
					this.$store.commit("setSelectedId", null)
					this.$store.commit("setSelectedTitle", "")
					this.$store.commit("setSelectedDescription", "")
					this.loadItems()
				}
			},
		},
	},
	methods: {
		loadItems() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			riskmatrixAPI
				.getAll("Inactive")
				.then((data) => {
					this.items = data[0]
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					// Select the first row by default
					if (this.items.length > 0) {
						this.selectRow(this.items[0], 0)
					}
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		selectRow(item, index) {
			this.selectedRowIndex = index
			this.$store.commit("setSelectedId", item.ID)
			this.$store.commit("setSelectedTitle", item.Title)
			this.$store.commit("setSelectedDescription", item.Description)
			if (this.hasScrolled) {
				const element = this.$refs.riskMatrixPoint
				if (element) {
					const offset = 100 // Adjust this value to fine-tune the scroll distance
					const elementPosition =
						element.getBoundingClientRect().top + window.scrollY
					const scrollToPosition = elementPosition - offset
					window.scrollTo({ top: scrollToPosition, behavior: "smooth" })
				}
			} else {
				this.hasScrolled = true 
			}
		},
		reloadComponent() {
			this.hasScrolled = false
			this.loadItems()
			this.newMatrixTitle = ""
			this.newMatrixDescription = ""
			this.newMatrixYear = ""
		},
		async makeitActive(item) {
			this.hasScrolled = false
			try {
				await riskmatrixAPI.updateRiskById(
					item.ID,
					item.Title,
					item.Description,
					item.Year,
					"Active"
				)
				this.$store.commit("setSelectedId", null)
				this.$store.commit("setSelectedTitle", "")
				this.$store.commit("setSelectedDescription", "")
				this.reloadComponent() // Reload data
			} catch (reason) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					reason,
					{ root: true }
				)
			}
		},
		async deleteItem(item) {
			this.hasScrolled = false
			this.delete = item.ID
			this.dialogDelete =true
		},
		async removeRow(){
			try {
				await riskmatrixAPI.deleteRisk(this.delete)
				this.reloadComponent() // Reload data
			} catch (reason) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					reason,
					{ root: true }
				)
			}
			this.dialogDelete =false
		}
	},
}
</script>

<style>
.toplayermargin {
	margin-top: 0px;
	transform: scale(0.8);
}

.matrix {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.matrix-btn {
	margin-right: 40px;
	margin-bottom: 20px;
}

.headline123 {
	margin-left: 180px;
	color: #1e7c83;
	font: inherit !important;
	font-weight: bolder !important;
}

.selected-row {
	background: #e0e0e0 !important;
}
</style>
